import { render, staticRenderFns } from "./apply_change.vue?vue&type=template&id=3f6cab54&scoped=true&"
import script from "./apply_change.vue?vue&type=script&lang=js&"
export * from "./apply_change.vue?vue&type=script&lang=js&"
import style0 from "./apply_change.vue?vue&type=style&index=0&id=3f6cab54&lang=scss&scoped=true&"
import style1 from "./apply_change.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6cab54",
  null
  
)

export default component.exports